module.exports = __webpack_public_path__ + "static/media/img2.21f17bfe.jpg";